'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  background-color: ', ';\n  color: ', ';\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 30px 20px;\n\n  svg {\n    display: block;\n  }\n\n  button {\n    margin-top: 20px;\n  }\n\n  @media (min-width: ', ') {\n    background-color: transparent;\n    color: ', ';\n    padding: 0 140px;\n  }\n'], ['\n  background-color: ', ';\n  color: ', ';\n  margin: 0 auto;\n  max-width: ', ';\n  padding: 30px 20px;\n\n  svg {\n    display: block;\n  }\n\n  button {\n    margin-top: 20px;\n  }\n\n  @media (min-width: ', ') {\n    background-color: transparent;\n    color: ', ';\n    padding: 0 140px;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CopyWrapper = _styledComponents2.default.div(_templateObject, _config.colors.lightGray, _config.colors.black, _config.breakpoints.xxl, _config.breakpoints.m, _config.colors.white);

CopyWrapper.displayName = 'CopyWrapper';

exports.default = CopyWrapper;